import React from 'react';
import PageTitle from 'components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RoutePaths } from 'Constants/Common';
import BaseAlert, {
    AlertId,
    AlertTypes
} from 'components/common/alerts/BaseAlert';

const MissedPaymentSuccessPage = () => {
    const { t } = useTranslation();

    return (
        <div className='page-content'>
            <PageTitle title={t('missed_payment.page_title')} />
            <div className='page-content-body p-3'>
                <BaseAlert
                    alertType={AlertTypes[AlertId.Success]}
                    includeImage
                    message={t('missed_payment.success_payment_message')}
                />
                <div className='d-grid gap-2 mt-4'>
                    <Link
                        to={RoutePaths.PersonalDetails}
                        data-testid='update-bank-details-button'
                        className='btn btn-primary'>
                        {t('button_label.update_bank_details')}
                    </Link>
                    <Link
                        to={RoutePaths.Home}
                        data-testid='your-details-button'
                        className='btn btn-secondary'>
                        {t('button_label.home_page')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default MissedPaymentSuccessPage;
